// extracted by mini-css-extract-plugin
export default {"title":"BaggagePolicies-module__title___czYVP","item":"BaggagePolicies-module__item___MyRkf","itemLink":"BaggagePolicies-module__itemLink___RD5jC"};